import { SUBMIT_FORCE_SCAN_REQUEST, SUBMIT_FORCE_SCAN_RESPONSE } from '../constants/action-types'

const forceScanReducer = (
  state = {
    isSubmittingForceScan: false,
    submitForceScanError: false,
    code: null,
    body: null
  },
  action
) => {
  switch (action.type) {
    case SUBMIT_FORCE_SCAN_REQUEST:
      return Object.assign({}, state, {
        isSubmittingForceScan: true
      })
    case SUBMIT_FORCE_SCAN_RESPONSE:
      return Object.assign({}, state, {
        submitForceScanError: action.error,
        isSubmittingForceScan: false,
        code: action.payload.status,
        body: action.payload.data.message
      })
    default:
      return state
  }
}

export default forceScanReducer



// WEBPACK FOOTER //
// ./src/reducers/force-scan-reducer.js